import { Input } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachmentsDetailComponent } from 'src/app/attachments/attachments-detail/attachments-detail.component';
import { AttachmentsService } from 'src/app/attachments/attachments.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { ViewsService } from 'src/app/core/view/views.service';
import { LoginService } from 'src/app/login/login.service';
import { MailingDetailComponent } from 'src/app/mailing/mailing-detail/mailing-detail.component';
import { ContactsService } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/contacts.service';
import { OrganizationsContactsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-contacts-detail/organizations-contacts-detail.component';
import { OrganizationsDetailGeneralComponent } from 'src/app/organizations/organizations-detail/organizations-detail-general/organizations-detail-general.component';
import { MeetingsService } from 'src/app/organizations/organizations-detail/organizations-meetings-detail/meetings.service';
import { OrganizationsMeetingsDetailComponent } from 'src/app/organizations/organizations-detail/organizations-meetings-detail/organizations-meetings-detail.component';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { TransactionsDetailComponent } from 'src/app/transactions/transactions-detail/transactions-detail.component';
import { TransactionsService } from 'src/app/transactions/transactions.service';
import { UsersService } from 'src/app/users/users.service';
import { TasksActionTypesService } from '../tasks-action-types.service';
import { TasksHistoriesService } from '../tasks-histories.service';
import { TasksHistoryDetailComponent } from '../tasks-history-detail/tasks-history-detail.component';
import { TasksStatusService } from '../tasks-status.service';
import { TasksService } from '../tasks.service';

@Component({
  selector: 'app-tasks-action-register',
  templateUrl: './tasks-action-register.component.html',
  styleUrls: ['./tasks-action-register.component.scss']
})
export class TasksActionRegisterComponent implements OnInit {
  @Input() public data: any
  @ViewChild("view") public view: ViewComponent;
  public task: any = {
    responsible_user_id: parseInt(this.loginService.get("userId")),
    organization_id: this.config.data.organization_id
  };
  public action:any = {
    task_action_scheduled_date: new Date()
  };
  public tasks_status: any = [];
  public tasksHistories: any = [];
  public events: any[];
  public taskHistory: any = {};
  public tasksActionTypes: any[];
  public responsibles: any = [];
  public connectedUser: any = {};
  public organizations: any = [];
  public meetings: any = [];
  public contacts: any = [];
  public lastGridEvent: any;
  public temp_task_action_id: any;
  public items: any[];

  constructor(
    private tasksService: TasksService,
    private tasksStatusService: TasksStatusService,
    private meetingsService: MeetingsService,
    private organizationsService: OrganizationsService,
    private contactsService: ContactsService,
    private usersService: UsersService,
    private tasksHistoriesService: TasksHistoriesService,
    private tasksActionTypesService: TasksActionTypesService,
    private transactionsService: TransactionsService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
    private loginService: LoginService,
    private attachmentsService: AttachmentsService,
    private viewsService: ViewsService,
  ) { }

  ngOnInit(): void {
    console.log("*********** task_action_register ESTA BORRADO........");

    /*this.items = [
      {
        label: '+1 día', command: () => {

          this.task.task_action_scheduled_date = new Date(new Date().getTime() + (24 * 60 * 60 * 1000));
          this.taskHistory.task_action_scheduled_date = this.task.task_action_scheduled_date;
          this.save(event);
        }
      },
      {
        label: '+2 días', command: () => {
          this.task.task_action_scheduled_date = new Date(new Date().getTime() + (2 * 24 * 60 * 60 * 1000));
          this.taskHistory.task_action_scheduled_date = this.task.task_action_scheduled_date;
          this.save(event);
        }
      },
      {
        label: '+3 días', command: () => {
          this.task.task_action_scheduled_date = new Date(new Date().getTime() + (3 * 24 * 60 * 60 * 1000));
          this.taskHistory.task_action_scheduled_date = this.task.task_action_scheduled_date;
          this.save(event);
        }
      },
      {
        label: '+1 semana', command: () => {
          this.task.task_action_scheduled_date = new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000));
          this.taskHistory.task_action_scheduled_date = this.task.task_action_scheduled_date;
          this.save(event);
        }
      }
    ];
    this.loadTasksActionTypes();
    this.loadTasksStatus();
    this.loadOrganizations();
    this.loadResponsibles();
    this.loadData(this.config.data.id);*/
  }

  loadData(id) {
    if (id) {
      this.tasksService.get(id).subscribe(
        data => {
          this.task = data;
          this.temp_task_action_id = this.task.task_action_id;
          this.loadTasksHistories();
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      )
    }
  }
  loadResponsibles() {
    this.usersService.all({}).subscribe(
      data => {
        this.responsibles = data.rows;
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
    this.usersService.get(this.loginService.get("userId")).subscribe(
      data => {
        this.connectedUser = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  loadOrganizations() {
    this.organizationsService.all({}).subscribe(
      data => {
        this.organizations = data.rows;
        this.loadContacts();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  loadContacts() {
    var organization_id = this.task.organization_id ? this.task.organization_id : 0;
    this.contactsService.all({ organization_id: organization_id }).subscribe(
      data => {
        this.contacts = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  loadTasksStatus() {
    this.tasksStatusService.all({}).subscribe(
      data => {
        this.tasks_status = data.rows;
        this.findDefaultStatus();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  loadTasksHistories() {
    this.tasksHistoriesService.all({ task_id: this.task.id }).subscribe(
      data => {
        this.tasksHistories = data.rows;
        if(this.tasksHistories[0]) this.action.task_action_id = this.tasksHistories[0].task_action_id;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  loadTasksActionTypes() {
    this.tasksActionTypesService.all({}).subscribe(
      data => {
        this.tasksActionTypes = data.rows;
      }
    )
  }

  loadMeetings() {
    this.meetingsService.all({}).subscribe(
      data => {
        this.meetings = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }

  save(event: any) {    
    if (typeof this.task.id === "undefined") {
      if (this.task.transaction_id == null || this.task.transaction_id == 0) this.task.transaction_id = this.config.data.transaction_id;
      this.task.date = new Date();
      if(this.action.task_action_id!=null && this.action.task_action_scheduled_date!=null){
        this.task.task_action_id = this.action.task_action_id;
        this.task.task_action_description = this.action.task_action_description;
        this.task.task_action_scheduled_date = this.action.task_action_scheduled_date;
      }
      this.tasksService.add(this.task).subscribe(
        data => {
          this.task = data;
          this.loadData(this.task.id);
          this.addInitialTaskHistory(this.task.id);
          this.messageService.add({ closable: false, severity: 'success', summary: "Actividad añadida correctamente." });
          this.loadData(this.task.id);
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      if(this.action.task_action_id!=null && this.action.task_action_scheduled_date!=null){
        this.task.task_action_id = this.action.task_action_id;
        this.task.task_action_description = this.action.task_action_description;
        this.task.task_action_scheduled_date = this.action.task_action_scheduled_date;
      }
      
      this.tasksService.save(this.task.id, this.task).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Actividad guardada correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }

  addInitialTaskHistory(task_id) {
    let taskHistory = {
      task_id: task_id,
      message: "Inicio de Actividad.",
      changed_by: this.connectedUser.id,
      changed_at: new Date(-5)
    }
    this.tasksHistoriesService.add(taskHistory).subscribe(
      data => {
        this.loadTasksHistories();
      },
      error => {
        this.messageService.add({ severity: "error", detail: error.error.title });
      }
    );
  }

  findDefaultStatus() {
    if (typeof this.task.task_status_id == "undefined") {
      this.tasks_status.forEach(element => {
        if (element.is_default) {
          this.task.task_status_id = element.id;
        }
      });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la actividad con asunto '" + this.task.subject + "'?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksService.delete(this.task.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.loadTasksHistories();
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  deleteTaskHistory(taskHistory) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el historial de actividad?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.tasksHistoriesService.delete(taskHistory.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            this.loadTasksHistories();
            this.view.fireEvent("tasks.histories", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  viewMeeting(meeting) {
    const ref = this.dialogService.open(OrganizationsMeetingsDetailComponent, {
      data: {
        id: meeting ? meeting.organization_id : this.task.organization_id,
        contactId: meeting ? meeting.contact_id : 0,
        meetingId: meeting ? meeting.id : 0,
        taskId: this.task.id,
        deactivated: meeting ? true : false
      },
      //header: meeting ? "Detalles de la reunión" : "Nueva reunión",
      width: '70%',
      //baseZIndex: 999
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("tasks.meetings", "reload");
    })
  }
  deleteMeeting(meeting) {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar el contacto " + meeting.subject + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.meetingsService.delete(meeting.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrado correctamente" });
            //this.loadMeetings(this.meetingsLastGridEvent);
            this.view.fireEvent("tasks.meetings", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }
  editTaskHistory(taskHistory) {
    const ref = this.dialogService.open(TasksHistoryDetailComponent, {
      data: {
        id: taskHistory ? taskHistory.organization_id : 0,
        taskId: this.task.id,
        taskHistory: taskHistory
      },
      header: taskHistory ? "Detalles del historial" : "Nuevo registro",
      width: '70%',
      //baseZIndex: 999
    });
    ref.onClose.subscribe((data: any) => {
      if (typeof (this.view) !== "undefined") this.viewsService.changeView(this.view.code);
      this.view.fireEvent("tasks.histories", "reload");
    })
  }


  onEvent(event) {
    if (event.component == "tasks.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.save(event);
    } else if (event.component == "tasks.histories") {
      if (event.event == "action" && event.action.name == "add") this.editTaskHistory(null);
      if (event.event == "action" && event.action.name == "edit") this.editTaskHistory(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteTaskHistory(event.data);
      if (event.event == "dblclick") this.editTaskHistory(event.data);
    } else if (event.component == "tasks.meetings") {
      if (event.event == "action" && event.action.name == "add") this.viewMeeting(null);
      if (event.event == "action" && event.action.name == "edit") this.viewMeeting(event.data);
      if (event.event == "action" && event.action.name == "delete") this.deleteMeeting(event.data);
      if (event.event == "dblclick") this.viewMeeting(event.data);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.task.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }

  status_selected(id) {
    this.task.task_status_id = id;
    this.tasksService.save(this.task.id, this.task).subscribe(
      data => {
        this.messageService.add({ closable: false, severity: "success", detail: "Estado actualizado correctamente" });
        this.loadData(this.task.id);
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    )
  }
}
